<template>

    <div class="container">
      <h1>Ølkort</h1>
      <Beer v-for="beer in beers" :key="beer.id"
        :beer="beer"
      ></Beer>

    </div>

</template>

<script>

import Beer from '../components/Beer.vue';

export default {
  name: 'BeerList',
  components: {
    Beer
  },
  props: {
    beers: Array
  }
}
</script>
